import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import { setReferralSourceList } from 'src/store/modules/admin'

import {
  REFERRAL_SOURCE_DELETE_MESSAGE,
  REFERRAL_SOURCE_GET_POST,
  REFERRAL_SOURCE_PATCH_DELETE_ITEM,
  REFERRAL_SOURCE_SAVE_MESSAGE,
  REFERRAL_SOURCE_UPDATE_MESSAGE
} from 'src/constants'
import { showSuccessModal } from 'src/services/dialogs'

export const getReferralSources = async (config = {}) => {
  try {
    const response = await httpClient.request({
      method: 'get',
      url: {
        pathname: REFERRAL_SOURCE_GET_POST,
        ...config
      }
    })

    return response
  } catch (err) {
    catchError(err)

    return { items: [], meta: {} }
  }
}

export const fetchReferralSourceList =
  (config = {}) =>
  async (dispatch) => {
    try {
      const { items = [], meta = {} } = await getReferralSources(config)

      dispatch(setReferralSourceList(items))

      return meta
    } catch (err) {
      catchError(err)
    }
  }

export const saveReferralSource =
  (config = {}) =>
  async () => {
    try {
      await httpClient.request({
        method: 'post',
        url: {
          pathname: REFERRAL_SOURCE_GET_POST
        },
        ...config
      })

      showSuccessModal({
        content: REFERRAL_SOURCE_SAVE_MESSAGE,
        centered: true,
        keyboard: false
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const updateReferralSource =
  (config = {}) =>
  async () => {
    const { payload = {}, params = {} } = config

    try {
      await httpClient.request({
        method: 'patch',
        url: {
          pathname: REFERRAL_SOURCE_PATCH_DELETE_ITEM,
          params
        },
        payload
      })

      showSuccessModal({
        content: REFERRAL_SOURCE_UPDATE_MESSAGE,
        centered: true,
        keyboard: false
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const deleteReferralSource =
  (config = {}) =>
  async () => {
    const { payload = {}, params = {} } = config

    try {
      await httpClient.request({
        method: 'delete',
        url: {
          pathname: REFERRAL_SOURCE_PATCH_DELETE_ITEM,
          params
        },
        payload
      })

      showSuccessModal({
        content: REFERRAL_SOURCE_DELETE_MESSAGE,
        centered: true,
        keyboard: false
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }
